<div [formGroup]="form">
  <ev-datepicker id="date"
    class="form-control"
    placeholder="__ . __ . _____"
    formControlName="date"
    style="width: 80px;display: inline-block;"
    [writeBack]="false"
    [future]="true">
  </ev-datepicker>

  @if (state.data$|async; as stateHolder) {
    @if (!!stateHolder.obj) {
      <div class="material-planning-signal click"
        style="display: inline-block;"
        (click)="open()">
        @switch (stateHolder.obj.status) {
          @case (0) {
            <i class="fa fa-info-circle impossible" style="font-size: 1.5em"></i>
          }
          @case (1) {
            <i class="fa fa-info-circle conflicts" style="font-size: 1.5em"></i>
          }
          @case (2) {
            <i class="fa fa-info-circle free" style="font-size: 1.5em"></i>
          }
        }
      </div>
    }
    @if (!stateHolder.obj && this.date && this.amount) {
      <i class="fa fa-question-circle click"
        style="font-size: 1.5em"
        (click)="checkDateAndOpen()"
        >
      </i>
    }
  } @else {
    <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
  }

  <loading-or-error #loadingOrError [loadingWrapper]="state"
    [errorMessage]="'Konnte Materialverfügbarkeit nicht berechnen.'"
    spinnerSize="1">
  </loading-or-error>
</div>
